/**
 * Above-the-fold JavaScript
 * =========================
 * Critical JavaScript for content visible on initial page load.
 * Keep this file minimal!
 */

// Remove no-js class to indicate JavaScript is enabled
document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

// Detect mobile/touch devices
if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    document.documentElement.classList.add('touch');
} else {
    document.documentElement.classList.add('no-touch');
}
